export const occasions = [
    "with_friends",
    "for_couples",
    "with_kids",
    "for_groups",
    "business_meal",
    "special_occasions",
    "table_for_one"
]